/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner } from './UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner';
import {
    UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSON,
    UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSONTyped,
    UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSON,
    UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSONTyped,
} from './UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner';
import type { ScreenerGeneratedDocumentType } from './ScreenerGeneratedDocumentType';
import {
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeFromJSONTyped,
    ScreenerGeneratedDocumentTypeToJSON,
    ScreenerGeneratedDocumentTypeToJSONTyped,
} from './ScreenerGeneratedDocumentType';

/**
 * 
 * @export
 * @interface UploadExternalEhrDocumentsRequest
 */
export interface UploadExternalEhrDocumentsRequest {
    /**
     * 
     */
    push_insurance_eligibility_check_results?: boolean;
    /**
     * 
     */
    push_clinic_package?: boolean;
    /**
     * 
     */
    push_full_clinic_package?: boolean;
    /**
     * 
     */
    clinic_package_document_ids?: Array<string>;
    /**
     * 
     */
    push_generated_document_types?: Array<ScreenerGeneratedDocumentType>;
    /**
     * For multi-instance document types, specify which instances to push
     */
    push_generated_document_instances?: Array<UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner>;
    /**
     * 
     */
    push_additional_document_ids?: Array<string>;
    /**
     * 
     */
    esign_request_id?: string;
    /**
     * 
     */
    esign_push_source?: UploadExternalEhrDocumentsRequestEsignPushSourceEnum;
    /**
     * MatrixCare Home Health DocumentTypeUploadID (GUID from the MC HH
     * lookups response). Required when external_ehr_type is
     * MATRIX_CARE_HOME_HEALTH; applied to every doc in this upload batch.
     * 
     */
    matrix_care_home_health_document_type_id?: string;
}


/**
 * @export
 */
export const UploadExternalEhrDocumentsRequestEsignPushSourceEnum = {
    Manual: 'manual',
    SystemAuto: 'system_auto',
} as const;
export type UploadExternalEhrDocumentsRequestEsignPushSourceEnum = typeof UploadExternalEhrDocumentsRequestEsignPushSourceEnum[keyof typeof UploadExternalEhrDocumentsRequestEsignPushSourceEnum];


/**
 * Check if a given object implements the UploadExternalEhrDocumentsRequest interface.
 */
export function instanceOfUploadExternalEhrDocumentsRequest(value: object): value is UploadExternalEhrDocumentsRequest {
    return true;
}

export function UploadExternalEhrDocumentsRequestFromJSON(json: any): UploadExternalEhrDocumentsRequest {
    return UploadExternalEhrDocumentsRequestFromJSONTyped(json, false);
}

export function UploadExternalEhrDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadExternalEhrDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'push_insurance_eligibility_check_results': json['push_insurance_eligibility_check_results'] == null ? undefined : json['push_insurance_eligibility_check_results'],
        'push_clinic_package': json['push_clinic_package'] == null ? undefined : json['push_clinic_package'],
        'push_full_clinic_package': json['push_full_clinic_package'] == null ? undefined : json['push_full_clinic_package'],
        'clinic_package_document_ids': json['clinic_package_document_ids'] == null ? undefined : json['clinic_package_document_ids'],
        'push_generated_document_types': json['push_generated_document_types'] == null ? undefined : ((json['push_generated_document_types'] as Array<any>).map(ScreenerGeneratedDocumentTypeFromJSON)),
        'push_generated_document_instances': json['push_generated_document_instances'] == null ? undefined : ((json['push_generated_document_instances'] as Array<any>).map(UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSON)),
        'push_additional_document_ids': json['push_additional_document_ids'] == null ? undefined : json['push_additional_document_ids'],
        'esign_request_id': json['esign_request_id'] == null ? undefined : json['esign_request_id'],
        'esign_push_source': json['esign_push_source'] == null ? undefined : json['esign_push_source'],
        'matrix_care_home_health_document_type_id': json['matrix_care_home_health_document_type_id'] == null ? undefined : json['matrix_care_home_health_document_type_id'],
    };
}

export function UploadExternalEhrDocumentsRequestToJSON(json: any): UploadExternalEhrDocumentsRequest {
    return UploadExternalEhrDocumentsRequestToJSONTyped(json, false);
}

export function UploadExternalEhrDocumentsRequestToJSONTyped(value?: UploadExternalEhrDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'push_insurance_eligibility_check_results': value['push_insurance_eligibility_check_results'],
        'push_clinic_package': value['push_clinic_package'],
        'push_full_clinic_package': value['push_full_clinic_package'],
        'clinic_package_document_ids': value['clinic_package_document_ids'],
        'push_generated_document_types': value['push_generated_document_types'] == null ? undefined : ((value['push_generated_document_types'] as Array<any>).map(ScreenerGeneratedDocumentTypeToJSON)),
        'push_generated_document_instances': value['push_generated_document_instances'] == null ? undefined : ((value['push_generated_document_instances'] as Array<any>).map(UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSON)),
        'push_additional_document_ids': value['push_additional_document_ids'],
        'esign_request_id': value['esign_request_id'],
        'esign_push_source': value['esign_push_source'],
        'matrix_care_home_health_document_type_id': value['matrix_care_home_health_document_type_id'],
    };
}

